module.exports = __webpack_public_path__ + "img/step42_a_tear_the_plastic.d094788c.png";